import { Component, OnDestroy, OnInit } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { OrdersService } from 'src/app/services/orders-services/orders.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-orders-dashboard',
  templateUrl: './orders-dashboard.component.html',
  styleUrls: ['./orders-dashboard.component.scss']
})
export class OrdersDashboardComponent implements OnInit, OnDestroy {

  orders;
  ordersKPI;
  getOrdersSubscription: Subscription;
  getOrdersKPISubscription: Subscription;

  constructor(private headerbreadcrumbService: HeaderBreadcrumbService,
              private ordersService: OrdersService) { }

  ngOnInit() {
    this.listenRefreshOrders();
    this.getOrders(moment().startOf('day').valueOf(), moment().valueOf());
    this.getOrdersKPI(moment().startOf('day').valueOf(), moment().valueOf());
    this.setBreadcrumb();
  }

  private listenRefreshOrders() {
    this.ordersService.listenRefreshOrders().pipe(
      tap(o => this.getOrders(o['from'], o['to'])),
      tap(o => this.getOrdersKPI(o['from'], o['to']))
    ).subscribe();
  }

  private getOrders(from, to) {
    this.getOrdersSubscription = this.ordersService.getOrders(from, to).pipe(
      map(o => this.orders = o)
    ).subscribe();
  }

  private getOrdersKPI(from, to) {
    this.getOrdersKPISubscription = this.ordersService.getOrdersKPI(from, to).pipe(
      map(o => this.ordersKPI = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerbreadcrumbService.setRoutes(new Breadcrumb('fas fa-shopping-bag', 'orders-page.orders'));
  }

  ngOnDestroy() {
    if (this.getOrdersSubscription) { this.getOrdersSubscription.unsubscribe(); }
    if (this.getOrdersKPISubscription) { this.getOrdersKPISubscription.unsubscribe(); }
  }
}
